<template>
  <v-card class="modal">
    <!-- Cabecera: dice QUE producto se edita, no solo "Editar producto".
         En una empresa con veinte productos abiertos desde una rejilla de
         tarjetas, saber en cual estas parado importa. -->
    <div class="modal-cabecera">
      <div>
        <div class="modal-etiqueta">
          <v-icon size="12">mdi-pencil</v-icon>
          Editando producto
        </div>
        <h2 class="modal-titulo">{{ localProduct.product || 'Producto' }}</h2>
      </div>
      <v-btn
        icon
        variant="text"
        size="small"
        class="modal-cerrar"
        @click="$emit('onClose')"
      >
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </div>

    <v-card-text class="modal-cuerpo">
      <div class="modal-grupo">Datos del producto</div>

      <div class="modal-grid-2">
        <v-text-field
          v-model="localProduct.product"
          class="fg-blue"
          label="Nombre del producto"
          variant="outlined"
          density="compact"
          maxlength="255"
        />
        <v-text-field
          v-model="localProduct.category"
          class="fg-blue"
          label="Categoría"
          variant="outlined"
          density="compact"
          maxlength="255"
        />
      </div>

      <v-textarea
        v-model="localProduct.description"
        class="fg-blue mt-2"
        label="Descripción"
        variant="outlined"
        density="compact"
        rows="4"
        :counter="2000"
        maxlength="2000"
        persistent-counter
        hint="Cuenta qué es, para qué sirve y qué lo hace distinto"
      />

      <v-text-field
        v-model="localProduct.costs"
        type="number"
        class="fg-blue mt-2"
        label="Precio"
        variant="outlined"
        density="compact"
        prefix="$"
        suffix="COP"
        :hint="precioFormateado"
        persistent-hint
      />

      <v-divider class="my-5" />

      <GaleriaEditable
        :imagenes="images"
        @agregar="dialogAddImage = true"
        @eliminar="deleteImage"
      />
    </v-card-text>

    <v-card-actions class="modal-pie">
      <v-spacer />
      <v-btn
        variant="text"
        :disabled="guardando"
        @click="$emit('onClose')"
      >
        Cancelar
      </v-btn>
      <v-btn
        color="primary"
        variant="flat"
        :loading="guardando"
        @click="saveChanges()"
      >
        <v-icon start>mdi-content-save</v-icon>
        Guardar cambios
      </v-btn>
    </v-card-actions>

    <v-dialog
      v-model="dialogAddImage"
      max-width="620"
      :persistent="subiendoImagenes"
    >
      <div style="text-align: -webkit-center;width: 100%;">
        <EntryLoalImage
          ref="entradaImagenes"
          multiple
          :subiendo="subiendoImagenes"
          :progreso="progresoSubida"
          @onImageSelected="saveImage"
        />
      </div>
    </v-dialog>

    <v-snackbar
      v-model="snackbar"
      :timeout="colorSnackbar === 'error' ? -1 : 3500"
      :color="colorSnackbar"
      location="top"
    >
      {{ mensajeSnackbar }}
      <template #actions>
        <v-btn variant="text" size="small" @click="snackbar = false">Cerrar</v-btn>
      </template>
    </v-snackbar>
  </v-card>
</template>
<script>
import apisProducts from '@/apis/apisProducts';
import EntryLoalImage from './Fields/EntryLoalImage.vue';
import GaleriaEditable from './Fields/GaleriaEditable.vue';
import { mensajeDeError } from '@/utils/errores';


export default {
  name: 'EditProduct',
  components: {
    EntryLoalImage,
    GaleriaEditable
  },
  props: {
    productId: {
      type: Number,
      required: true
    }
  },
  emits: ["alEditarCorrectamente", "onClose"],
  computed: {
    /** El campo es numerico y crudo: 150000 no se lee. Debajo se
     *  muestra como lo vera el cliente en el catalogo. */
    precioFormateado() {
      const valor = Number(this.localProduct.costs)
      if (!this.localProduct.costs || isNaN(valor)) {
        return 'Sin precio se mostrará como "Consultar"'
      }
      return `Se verá como ${valor.toLocaleString('es-CO')} COP`
    }
  },
  data() {
    return {
      localProduct: {
        idProduct: null,
        product: '',
        category: '',
        description: '',
        costs: 0,
        views: 0
      },
      images: [],
      dialogAddImage: false,
      guardando: false,
      subiendoImagenes: false,
      progresoSubida: '',
      snackbar: false,
      mensajeSnackbar: '',
      colorSnackbar: 'success'
    }
  },
  created() {
    apisProducts.getProductById(this.productId)
      .then(response => {
        this.localProduct = response;
        this.loadImages();
      })
      .catch(error => {
        console.error("Error fetching product data:", error);
      });
  },
  methods: {
    saveChanges() {
      this.guardando = true;
      apisProducts.saveProductEdit(this.localProduct)
        .then(res => {
          this.$emit('alEditarCorrectamente', res);
          this.$emit('onClose');
        })
        .catch(error => {
          this.avisar(mensajeDeError(error, 'No se pudieron guardar los cambios'), 'error');
        })
        .finally(() => {
          this.guardando = false;
        });
    },
    loadImages() {
      apisProducts.ImagesProducts(this.localProduct.idProduct)
        .then(response => {
          this.images = response;
        })
        .catch(error => {
          console.error("Error loading images:", error);
        });
    },
    /**
     * Recibe una o varias imagenes en base64. Se suben de a una y no en
     * paralelo: cada una viaja como base64 dentro del JSON y mandarlas todas
     * juntas satura el servidor.
     */
    async saveImage(imagenes) {
      const lista = Array.isArray(imagenes) ? imagenes : [imagenes];

      if (lista.length === 0) {
        return;
      }

      this.subiendoImagenes = true;
      let fallidas = 0;

      for (let i = 0; i < lista.length; i++) {
        this.progresoSubida = `Subiendo ${i + 1} de ${lista.length}...`;

        try {
          await apisProducts.imageSave(lista[i], this.productId);
        } catch (error) {
          console.error("Error saving image:", error);
          fallidas++;
        }
      }

      this.subiendoImagenes = false;
      this.progresoSubida = '';
      this.loadImages();

      const subidas = lista.length - fallidas;

      if (fallidas === 0) {
        this.avisar(`${subidas} imagen(es) subida(s)`, 'success');
        if (this.$refs.entradaImagenes) {
          this.$refs.entradaImagenes.limpiar();
        }
        this.dialogAddImage = false;
      } else {
        // El dialogo se queda abierto para poder reintentar con las que fallaron
        this.avisar(
          `${subidas} subida(s), ${fallidas} fallaron. Puede que sean muy grandes o de un formato no soportado.`,
          'error'
        );
      }
    },
    avisar(mensaje, color) {
      this.mensajeSnackbar = mensaje;
      this.colorSnackbar = color;
      this.snackbar = true;
    },
    deleteImage(idImage) {
      apisProducts.deleteImage(idImage)
        .then(() => {
          this.loadImages();
        })
        .catch(error => {
          console.error("Error deleting image:", error);
        });
    }
  }
}
</script>
<style scoped>
/* El diseno del modal vive en styles/overwirthe.css, compartido con los
   demas modales. Aqui solo lo propio de este. */
</style>
